import { FieldComponentType } from "@smart/bridge-intake-components-dom";
import { FieldNS } from "@smart/bridge-types-basic";
import { useDeleteGroup, useUpdateGroup } from "@smart/manage-gql-client-dom";

import { baseLanguageKey } from "../../../types";
import { fieldComponentDraggableIdPrefix } from "../constants";
import { FieldComponent } from "../navigation/field-component";
import { Field } from "../questions/field";
import { Group } from "../questions/group";
import {
  GqlMatterLayout,
  GqlMatterType,
  QuestionEditMode,
  GqlSectionItem,
  GqlField,
  GqlGroupWithFieldValues,
} from "../types";

type DragOverlayDisplayProps = {
  activeId: string;
  sectionFields: GqlField[] | undefined;
  sectionItems: GqlSectionItem[];
  questionEditMode: QuestionEditMode;
  matterTypes: GqlMatterType[] | undefined;
  matterLayouts: GqlMatterLayout[] | undefined;
  delta?: {
    x: number;
    y: number;
  };
};

export const DragOverlayDisplay = ({
  activeId,
  sectionFields,
  sectionItems,
  questionEditMode,
  matterTypes,
  matterLayouts,
  delta,
}: DragOverlayDisplayProps) => {
  if (activeId.startsWith(fieldComponentDraggableIdPrefix)) {
    return (
      <FieldComponent
        type={
          activeId.replace(
            `${fieldComponentDraggableIdPrefix}-`,
            "",
          ) as FieldComponentType
        }
        isDragging
        delta={delta}
      />
    );
  }

  const conditionActions = {
    checkHasConditions: () => false,
    setEditingCondition: () => {},
    getNumberOfConditions: () => 0,
  };

  if (FieldNS.isUriMatch(activeId)) {
    const fieldValue = sectionFields?.find((f) => f.uri === activeId)?.values;

    return (
      fieldValue && (
        <Field
          index={0}
          item={fieldValue}
          mode={questionEditMode}
          matterTypes={matterTypes}
          onUpdateField={async () => {}}
          onDeleteField={async () => {}}
          matterLayouts={matterLayouts}
          loadMatterFields={async () => []}
          conditionActions={conditionActions}
          onFieldTypeChange={async () => {}}
          excludingFieldTemplates={[]}
          isDragging
          lastActiveIds={[]}
          viewingLanguage={baseLanguageKey}
        />
      )
    );
  }

  const group = sectionItems.find(
    (s) => s.uri === activeId,
  ) as GqlGroupWithFieldValues;

  return (
    group && (
      <Group
        mode={questionEditMode}
        index={0}
        item={group}
        fields={group.fields}
        matterTypes={matterTypes}
        updateGroup={
          (async () => {}) as unknown as ReturnType<typeof useUpdateGroup>[0]
        }
        deleteGroup={
          (async () => {}) as unknown as ReturnType<typeof useDeleteGroup>[0]
        }
        duplicateGroup={async () => {}}
        sectionItems={sectionItems}
        onUpdateField={async () => {}}
        onDeleteField={async () => {}}
        matterLayouts={matterLayouts}
        loadMatterFields={async () => []}
        updatingItems={{}}
        conditionActions={conditionActions}
        onFieldTypeChange={async () => {}}
        excludingFieldTemplates={[]}
        isDragging
        lastActiveIds={[]}
        viewingLanguage={baseLanguageKey}
        formFields={[]}
        formGroups={[]}
      />
    )
  );
};
